<template>
  <div id="tablePage">
    <!-- 历史委托查询 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        :cell-class-name="directionClass"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="orderId"
          label="委托单号"
        >
        </el-table-column>
        <el-table-column
          prop="commodityCode"
          label="商品代码"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买|卖"
          sortable="custom"
        >
          <!-- <template slot-scope="scope">
            <span :class="scope.row.bsFlag=='B'?'red-row':'green-row'"> {{ scope.row.bsFlag=='B'?'买入':'卖出' }}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="orderType" label="订立|转让" width="110">
          <template slot-scope="scope">
            {{ scope.row.orderType|tradeTypeFormat }}
          </template>
        </el-table-column>
        <el-table-column
          prop="singlePrice"
          label="委托价格"
          sortable="custom"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ Number(scope.row.singlePrice).toFixed(scope.row.priceScale) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="initQuantity"
          label="委托数量"
        >
          <template slot-scope="scope">
            <span v-if="isHistory"> {{ scope.row.quantity }}</span>
            <span v-else> {{ scope.row.initQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="未成交数量"
        >
          <template slot-scope="scope">
            <span class=" green-row " v-if="isHistory"> {{ scope.row.unDealQuantity }}</span>
            <span class=" green-row " v-else> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="availableQuantity"
          label="已成交数量"
        >
          <template slot-scope="scope">
            <span class=" red-row " v-if="isHistory"> {{ scope.row.availableQuantity }}</span>
            <span class=" red-row " v-else> {{ util.floatSub(scope.row.initQuantity, scope.row.quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderStatus"
          label="状态"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.orderStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="委托时间"
          width="90"
        >

        </el-table-column>
        <el-table-column
          prop="cancelDealTime"
          label="撤单时间"
          width="90"
        >
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['time', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      isHistory: false, // 是否为历史接口
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      OrderFrontSum: {
        availableQuantity: null,
        bsFlag: '',
        cancelDealTime: null,
        commodityCode: '',
        commodityId: 0,
        commodityName: '',
        createTime: null,
        firmId: 0,
        frozeFee: null,
        frozeMargin: null,
        holdDetailId: 0,
        initQuantity: 0,
        minPriceChange: 0,
        ocFlag: '',
        orderId: 0,
        orderStatus: 0,
        orderType: 0,
        priceScale: 0,
        quantity: null,
        singlePrice: 0,
        tradeDay: 0,
        unDealQuantity: null,
        unitNumeral: 0,
        updateTime: null
      },
      isNetWrong: false,
      beginTime: [util.formatnewDay(Number(new Date())), util.formatnewDay(Number(new Date()))]
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter', 'commodityStrategyGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      let currentProtocol = protocol.queryUserEntrustsNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserEntrustHSNEW
        currentProtocol.data.startTradeDay = this.time[0]
        currentProtocol.data.endTradeDay = this.time[1]
        this.isHistory = true
        currentProtocol.data.page = this.pageData.currentPage
      } else {
        this.isHistory = false
        currentProtocol.data.page = this.pageData.currentPage - 1
      }
      currentProtocol.data.size = '' + this.pageData.pageSize
      currentProtocol.data.bsFlag = null
      currentProtocol.data.commodityId = null
      currentProtocol.data.orderStatus = null
      currentProtocol.data.orderType = [1, 2, 4, 15]
      http.gPostHs(currentProtocol).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.isHistory = true
            } else {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.isHistory = false
            }
          }
        }
        // this.querySum()
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        if (arrIndex.cancelDealTime) {
          that.modifyTime(arrIndex, 'cancelDealTime')
        }
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      let currentProtocol = protocol.queryUserEntrustsNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserEntrustHSNEW
      }
      if (column.order == 'ascending') {
        currentProtocol.data.sort = [{
          'direction': 'ASC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        currentProtocol.data.sort = [{
          'direction': 'DESC',
          'property': ''
        }]
        this.eachSortChange(column.column.property)
      } else {
        currentProtocol.data.sort = [{
          direction: 'DESC',
          property: 'orderId'
        }]
      }
      if (column.column) {
        http.gPostHs(currentProtocol).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
                this.pageData.total = response.data.value.total
                const arr = response.data.value.list
                this.judgeDataType(arr)
                this.isHistory = true
              } else {
                this.pageData.total = response.data.value.totalElements
                const arr = response.data.value.content
                this.judgeDataType(arr)
                this.isHistory = false
              }
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      let currentProtocol = protocol.queryUserEntrustsNew
      if (this.time[0] != this.beginTime[0] || this.time[1] != this.beginTime[1]) {
        currentProtocol = protocol.queryUserEntrustHSNEW
      }
      return (currentProtocol.data.sort[0].property = str)
    },
    // 查询合计
    querySum() {
      if (this.time) {
        // 历史
        protocol.queryOrderFrontHSum.data.startTradeDay = this.time[0]
        protocol.queryOrderFrontHSum.data.endTradeDay = this.time[1]
      } else {
        protocol.queryOrderFrontHSum.data.startTradeDay = null
        protocol.queryOrderFrontHSum.data.endTradeDay = null
      }
      protocol.queryOrderFrontHSum.data.bsFlag = null
      protocol.queryOrderFrontHSum.data.commodityId = null
      // protocol.queryOrderFrontHSum.data.orderStatus = this.search.status != null ? [this.search.status] : null
      http.gPostHs(protocol.queryOrderFrontHSum).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            // const arr = response.data.value.content
            this.OrderFrontSum = response.data.value
          } else {
            this.$message(response.data.message)
          }
        }
      })
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 3: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        case 4: {
          return this.setStrClass(row.row.ocFlag, '转让', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 2) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 6) { // 委托数量
          sums[index] = that.OrderFrontSum.initQuantity
          return
        }
        if (index === 7) { // 未成交数量
          sums[index] = that.OrderFrontSum.unDealQuantity
          return
        }
        if (index === 8) { // 已成交数量
          sums[index] = that.OrderFrontSum.frozeMargin
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>

